// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".patient-card[data-v-8f2735c0]{border:1px solid #1cacda;height:100%;cursor:pointer;position:relative}.overlay[data-v-8f2735c0]{width:100%;height:100%;position:absolute;top:0;left:0;background:hsla(0,0%,100%,.3764705882352941)}.patient-item[data-v-8f2735c0]{text-overflow:ellipsis;overflow:hidden;margin-bottom:.15rem;font-weight:500}.search-result-list[data-v-8f2735c0]{overflow:auto;max-height:550px;padding-bottom:80px!important}", ""]);
// Exports
module.exports = exports;
